module.exports = __webpack_public_path__ + "img/bz_zx.736f06bc.png";